import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 264 107",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "48.5",
      y: "46.5",
      width: "159",
      height: "31",
      rx: "7.5",
      fill: "var(--dt-color-surface-primary)",
      stroke: "var(--dt-color-border-brand)",
      id: "box"
    }, null, -1),
    _createElementVNode("rect", {
      x: "64",
      y: "30",
      width: "55",
      height: "8",
      rx: "4",
      fill: "var(--dt-color-surface-moderate)",
      id: "box"
    }, null, -1),
    _createElementVNode("rect", {
      x: "64",
      y: "58",
      width: "97",
      height: "8",
      rx: "4",
      fill: "var(--dt-color-foreground-placeholder",
      id: "label"
    }, null, -1)
  ]))]))
}
export default { render: render }